import React from 'react'
import { Alert, Spinner, Badge } from 'react-bootstrap'
import { useCustomAnalyticRun } from 'api/hooks/use-custom-analytics'

const STATUS_VARIANTS = {
  pending: 'info',
  running: 'info',
  complete: 'success',
  error: 'danger'
}

const RunStatusBanner = ({ municipalityId, runId }) => {
  const { data: run } = useCustomAnalyticRun({
    municipalityId,
    id: runId,
    options: {
      refetchInterval: (data) => {
        if (!data) return 3000
        // Poll only while the run is known to be active — an unknown status
        // (e.g. a new terminal state added on the API side) fails safe by
        // stopping the poll rather than polling forever.
        return ['pending', 'running'].includes(data.status) ? 3000 : false
      }
    }
  })

  if (!run) {
    return (
      <Alert variant="info" className="d-flex align-items-center">
        <Spinner size="sm" animation="border" className="me-2" />
        Starting custom analytics run…
      </Alert>
    )
  }

  return (
    <Alert variant={STATUS_VARIANTS[run.status] || 'info'} className="d-flex align-items-center">
      {['pending', 'running'].includes(run.status) && (
        <Spinner size="sm" animation="border" className="me-2" />
      )}
      <div className="flex-grow-1">
        <strong>Status:</strong> <Badge bg="light" text="primary">{run.status}</Badge>
        {run.flags_count != null && (
          <> · <strong>Flags:</strong> {run.flags_count}</>
        )}
        {run.message && (
          <div className="small mt-1"><code>{run.message}</code></div>
        )}
      </div>
    </Alert>
  )
}

export default RunStatusBanner
